import React, { useState } from 'react';

// Wrap any control. If `enabled` is false, the control renders greyed,
// non-clickable, with a 🔒 and an ⓘ tooltip explaining where it's available.
export default function FeatureGate({ enabled, plan = 'a paid plan', blurb, children }) {
  const [show, setShow] = useState(false);
  if (enabled) return <>{children}</>;
  return (
    <span className="feature-gate-locked">
      <span className="feature-gate-content">{children}</span>
      <span className="feature-gate-lock">🔒</span>
      <span
        className="feature-gate-info"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onClick={(e) => { e.stopPropagation(); setShow((s) => !s); }}
      >
        ⓘ
        {show && (
          <span className="feature-gate-tooltip">
            {blurb || `Available in ${plan}.`}
          </span>
        )}
      </span>
    </span>
  );
}